import { render, staticRenderFns } from "./GroupedFormSubmissions.vue?vue&type=template&id=3e8176cd&scoped=true&"
import script from "./GroupedFormSubmissions.vue?vue&type=script&lang=js&"
export * from "./GroupedFormSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./GroupedFormSubmissions.vue?vue&type=style&index=0&id=3e8176cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8176cd",
  null
  
)

export default component.exports